import { Main5SectionWrap, Main5SectionContent, Main5SectionItem } from 'src/styles/views/Main/main5'
import main5bg1 from 'src/assets/main/main5/main5bg_1.png'
import main5bg2 from 'src/assets/main/main5/main5bg_2.png'
import mo_main5bg1 from 'src/assets/main/main5/mo_main5bg_1.png'
import mo_main5bg2 from 'src/assets/main/main5/mo_main5bg_2.png'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import main5img1 from 'src/assets/main/main5/main5_phone_img1.png'
import main5img2 from 'src/assets/main/main5/main5_phone_img2.png'

const Main5Section = () => {
  const { width } = useWindowDimensions()
  return (
    <Main5SectionWrap>
      <Main5SectionContent bgImgSrc={width > 1200 ? main5bg1 : mo_main5bg1}>
        <Main5SectionItem>
          <img src={main5img1} alt='' />
          <div>
            <h3>운동기록 확인하기</h3>
            <p>최대 90일 까지의 운동 기록을 확인할 수 있어요.</p>
          </div>
        </Main5SectionItem>
      </Main5SectionContent>
      <Main5SectionContent bgImgSrc={width > 1200 ? main5bg2 : mo_main5bg2}>
        <Main5SectionItem>
          <img src={main5img2} alt='' />
          <div>
            <h3> 목표달성! 응원, 칭찬하기</h3>
            {
              width > 1200 ?
                <p>서로의 목표를 확인하고 달성 전에는 응원을, 달성 후에는 칭찬을 해보세요.</p> :
                <p>패밀리랭킹으로 운동목표를 달성해보세요!</p>
            }
          </div>
        </Main5SectionItem>
      </Main5SectionContent>
    </Main5SectionWrap>
  )
}
export default Main5Section
